<template>
  <div class="social-campaigns container-fluid py-4">
    <div class="row h-100">
      <!-- Sidebar: Configuration -->
      <div class="col-lg-4 col-xl-3 mb-4">
        <div class="config-sidebar sticky-top" style="top: 20px;">
          <div class="glass-card p-4">
            <h5 class="mb-4 d-flex align-items-center">
              <div class="icon-circle bg-primary-soft me-2">
                <i class="fas fa-bullhorn"></i>
              </div>
              Nuova Campagna AI
            </h5>

            <div class="mb-3">
              <label class="form-label small fw-bold">Tipologia Campagna</label>
              <select class="form-select form-select-sm" v-model="campaignSettings.type">
                <option value="awareness">Notorietà (Brand Awareness)</option>
                <option value="consideration">Interazione (Traffico, Messaggi)</option>
                <option value="conversion">Conversione (Vendite, Prenotazioni)</option>
              </select>
            </div>

            <div class="mb-3">
              <label class="form-label small fw-bold">Nome Campagna Facebook</label>
              <input type="text" class="form-control form-control-sm" v-model="campaignSettings.fb_campaign_name" placeholder="Es. Promo Estate 2025...">
            </div>

            <div class="mb-3">
              <label class="form-label small fw-bold">Prompt IA per Copy</label>
              <textarea class="form-control form-control-sm" v-model="campaignSettings.ai_prompt_text" rows="2" placeholder="Cosa pubblicizzare? (es. Sconto 20% su pizze)"></textarea>
            </div>

            <div class="mb-3">
              <label class="form-label small fw-bold">ID Account Facebook</label>
              <input type="text" class="form-control form-control-sm" v-model="campaignSettings.adAccountId" placeholder="Es. 363756839...">
            </div>

            <div class="row g-2 mb-3">
              <div class="col-6">
                <label class="form-label small fw-bold">Budget Giornaliero</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text bg-light border-end-0">€</span>
                  <input type="number" class="form-control border-start-0" v-model="campaignSettings.dailyBudget" min="1">
                </div>
              </div>
              <div class="col-6">
                <label class="form-label small fw-bold">Budget Totale</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text bg-light border-end-0">€</span>
                  <input type="number" class="form-control border-start-0" v-model="campaignSettings.totalBudget" min="1">
                </div>
              </div>
            </div>

            <div class="row g-2 mb-3">
              <div class="col-6">
                <label class="form-label small fw-bold">Data Inizio</label>
                <input type="date" class="form-control form-control-sm" v-model="campaignSettings.startDate">
              </div>
              <div class="col-6">
                <label class="form-label small fw-bold">Data Fine</label>
                <input type="date" class="form-control form-control-sm" v-model="campaignSettings.endDate">
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label small fw-bold">Info Attività / Note</label>
              <textarea class="form-control form-control-sm" v-model="campaignSettings.businessInfo" rows="2" placeholder="Es. Promozione piatti speciali..."></textarea>
            </div>

            <div class="mb-4">
              <label class="form-label d-block small fw-bold">Modalità Pubblicazione:</label>
              <div class="btn-group w-100" role="group">
                <input type="radio" class="btn-check" name="campPublishMode" id="campModeAuto" value="auto" v-model="campaignSettings.publishMode">
                <label class="btn btn-outline-primary btn-sm" for="campModeAuto">Auto</label>
                
                <input type="radio" class="btn-check" name="campPublishMode" id="campModeDraft" value="draft" v-model="campaignSettings.publishMode">
                <label class="btn btn-outline-primary btn-sm" for="campModeDraft">Agente</label>
              </div>
            </div>

            <div class="form-check form-switch mb-4">
              <input class="form-check-input" type="checkbox" id="statusToggle" v-model="campaignSettings.status_toggle">
              <label class="form-check-label small fw-bold" for="statusToggle">Attiva Immediatamente</label>
            </div>

            <button class="btn btn-primary w-100 shadow-sm" @click="startCampaignAgent" :disabled="isLoading">
              <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
              <i v-else class="fas fa-magic me-2"></i>Avvia Agente
            </button>
          </div>
          
          <div class="mt-4 p-3 bg-info-soft rounded border border-info border-opacity-25 small text-info text-center">
            <i class="fas fa-shield-alt me-1"></i>L'agente ottimizzerà il budget basandosi sulle performance storiche.
          </div>
        </div>
      </div>

      <!-- Main Content: Campaign Feed -->
      <div class="col-lg-8 col-xl-9">
        <div class="feed-header d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
          <h4 class="mb-0 fw-bold">Le Tue Campagne</h4>
          
          <div class="d-flex gap-2 align-items-center">
            <div class="search-bar">
              <i class="fas fa-search"></i>
              <input type="text" class="form-control form-control-sm" placeholder="Cerca campagna..." v-model="searchQuery">
            </div>
            
            <select class="form-select form-select-sm status-filter" v-model="typeFilter">
              <option value="ALL">Tutti i tipi</option>
              <option value="awareness">Notorietà</option>
              <option value="consideration">Interazione</option>
              <option value="conversion">Conversione</option>
            </select>

            <button class="btn btn-light btn-sm rounded-circle border shadow-sm" @click="loadCampaigns" title="Aggiorna">
              <i class="fas fa-sync-alt"></i>
            </button>
          </div>
        </div>

        <!-- Feed Container -->
        <div class="campaign-feed-container">
          <div v-if="hasNoCampaigns" class="empty-state text-center py-5">
            <div class="empty-illustration mb-3">
              <i class="fas fa-ad fa-4x text-muted opacity-25"></i>
            </div>
            <h3>Nessuna campagna</h3>
            <p class="text-muted">Inizia a promuovere la tua attività con l'AI.</p>
          </div>

          <div v-if="!hasNoCampaigns" class="campaign-timeline">
            <div v-for="(group, monthName) in groupedCampaignsByMonth" :key="'month-'+monthName" class="month-section mb-5">
              <h5 class="month-title mb-4">
                <span>{{ monthName }}</span>
                <div class="title-line"></div>
              </h5>
              
              <div class="row g-4">
                <div v-for="campaign in group" :key="'camp-'+campaign._id" class="col-12 col-xl-6">
                  <div class="campaign-card shadow-sm" :class="{ 'is-active': campaign.status === 'ACTIVE' }">
                    <div class="card-header-custom d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h6 class="campaign-name mb-1 fw-bold text-dark">{{ campaign.name || 'Senza Nome' }}</h6>
                        <span class="badge" :class="getTypeBadgeClass(campaign.type)">
                          {{ getCampaignTypeLabel(campaign.type) }}
                        </span>
                      </div>
                      <span class="badge rounded-pill" :class="getStatusBadgeClass(campaign.status)">
                        {{ getStatusLabel(campaign.status) }}
                      </span>
                    </div>
                    
                    <div class="campaign-content row g-3">
                      <div class="col-md-7">
                        <div class="stats-grid row g-2 mb-3">
                          <div class="col-6">
                            <div class="stat-item p-2 rounded bg-light border">
                              <label class="d-block small text-muted mb-0 fw-bold">Budget Day</label>
                              <span class="fw-bold">€{{ campaign.budgetDaily || 0 }}</span>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="stat-item p-2 rounded bg-light border">
                              <label class="d-block small text-muted mb-0 fw-bold">Budget Totale</label>
                              <span class="fw-bold text-primary">€{{ campaign.budgetTotal || 0 }}</span>
                            </div>
                          </div>
                        </div>

                        <div v-if="campaign.adContent" class="ad-preview-box p-3 rounded mb-2 border-start border-4 border-primary bg-light shadow-xs">
                          <label class="d-block small fw-bold text-muted mb-1 text-uppercase">Contenuto Annuncio</label>
                          <p class="mb-0 small text-dark ad-text">{{ campaign.adContent }}</p>
                        </div>
                        <div v-if="!campaign.adContent && campaign.status === 'PENDING_AGENT'" class="text-center py-3 text-muted">
                          <div class="spinner-border spinner-border-sm text-primary me-2"></div>
                          <span class="small italic">L'agente sta creando l'annuncio...</span>
                        </div>
                        <div v-if="campaign.agentError && campaign.status === 'FAILED'" class="alert alert-danger p-2 mt-2 small">
                          <i class="fas fa-exclamation-triangle me-1"></i> {{ campaign.agentError }}
                        </div>
                      </div>

                      <div class="col-md-5">
                        <div v-if="campaign.adImage" class="ad-image-container rounded overflow-hidden shadow-sm border">
                          <img :src="getImageUrl(campaign.adImage)" class="w-100 h-100 object-fit-cover" alt="Ad">
                        </div>
                        <div v-if="!campaign.adImage" class="ad-image-placeholder rounded bg-light d-flex align-items-center justify-content-center border-dashed">
                          <i class="fas fa-image text-muted opacity-25 fa-2x"></i>
                        </div>
                      </div>
                    </div>
                    
                    <div class="campaign-footer mt-auto pt-3 border-top d-flex flex-wrap justify-content-between align-items-center gap-2">
                      <div class="duration-info small text-muted">
                        <i class="far fa-calendar-check me-1"></i>
                        {{ formatDate(campaign.startDate) }} <i class="fas fa-long-arrow-alt-right mx-1"></i> {{ formatDate(campaign.endDate) }}
                      </div>
                      <div v-if="campaign.processedAt" class="small text-muted italic">
                        <i class="fas fa-chart-line me-1 opacity-50"></i>Ottimizzata: {{ formatDate(campaign.processedAt) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store/store.js'

export default {
  name: 'SocialCampaigns',
  data() {
    return {
      store,
      userId: (localStorage.token_id && localStorage.token_id !== 'undefined') ? JSON.parse(localStorage.token_id)._id : 'test_user_id',
      searchQuery: '',
      typeFilter: 'ALL',
      campaignSettings: {
        type: 'awareness',
        fb_campaign_name: '',
        ai_prompt_text: '',
        status_toggle: false,
        dailyBudget: 5,
        totalBudget: 50,
        publishMode: 'auto',
        adAccountId: '',
        businessInfo: '',
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10)
      },
      campaigns: [],
      isLoading: false
    }
  },
  computed: {
    hasNoCampaigns() {
        return Object.keys(this.groupedCampaignsByMonth).length === 0;
    },
    groupedCampaignsByMonth() {
      const groups = {};
      
      // Defensive check for campaigns array
      if (!Array.isArray(this.campaigns)) return groups;
      
      const filtered = this.campaigns.filter(c => {
        if (!c) return false;
        const name = c.name || '';
        const matchesSearch = !this.searchQuery || name.toLowerCase().includes(this.searchQuery.toLowerCase());
        const matchesType = this.typeFilter === 'ALL' || c.type === this.typeFilter;
        return matchesSearch && matchesType;
      });

      filtered.forEach(camp => {
        const d = camp.startDate || camp.createdAt;
        const date = new Date(d);
        if (isNaN(date.getTime())) return;
        
        const monthYear = date.toLocaleString('it-IT', { month: 'long', year: 'numeric' });
        if (!groups[monthYear]) groups[monthYear] = [];
        groups[monthYear].push(camp);
      });

      // Sort months descending
      const sortedKeys = Object.keys(groups).sort((a, b) => {
        if (!groups[a] || !groups[a][0] || !groups[b] || !groups[b][0]) return 0;
        const dateA = new Date(groups[a][0].startDate || groups[a][0].createdAt);
        const dateB = new Date(groups[b][0].startDate || groups[b][0].createdAt);
        const timeA = isNaN(dateA.getTime()) ? 0 : dateA.getTime();
        const timeB = isNaN(dateB.getTime()) ? 0 : dateB.getTime();
        return timeB - timeA;
      });

      const result = {};
      sortedKeys.forEach(key => {
        result[key] = [...groups[key]].sort((a, b) => {
          const dateA = new Date(a.createdAt);
          const dateB = new Date(b.createdAt);
          const timeA = isNaN(dateA.getTime()) ? 0 : dateA.getTime();
          const timeB = isNaN(dateB.getTime()) ? 0 : dateB.getTime();
          return timeB - timeA;
        });
      });
      return result;
    }
  },
  mounted() {
    this.loadCampaigns();
  },
  methods: {
    async startCampaignAgent() {
      this.isLoading = true;
      try {
        const apiBase = this.store.path || 'http://localhost:5000/login/'; 
        const endpoint = apiBase.endsWith('/') ? `${apiBase}social/campaigns` : `${apiBase}/social/campaigns`;

        let token = '';
        try {
            if (localStorage.token && localStorage.token !== 'undefined') {
                token = JSON.parse(localStorage.token);
            }
        } catch(e) {
            token = localStorage.token;
        }

        await this.axios.post(endpoint, {
            userId: this.userId,
            name: this.campaignSettings.fb_campaign_name || `Campagna ${this.campaignSettings.type.toUpperCase()} - ${new Date().toLocaleDateString()}`,
            fb_campaign_name: this.campaignSettings.fb_campaign_name,
            ai_prompt_text: this.campaignSettings.ai_prompt_text,
            status_toggle: this.campaignSettings.status_toggle,
            budgetDaily: this.campaignSettings.dailyBudget,
            budgetTotal: this.campaignSettings.totalBudget,
            type: this.campaignSettings.type,
            startDate: this.campaignSettings.startDate,
            endDate: this.campaignSettings.endDate,
            businessInfo: this.campaignSettings.businessInfo,
            adAccountId: this.campaignSettings.adAccountId,
            agentSettings: {
                publishMode: this.campaignSettings.publishMode,
                generateImageAI: true
            }
        }, {
            headers: {
                 authorization: `Bearer ${token}`
            }
        });

        alert('Agente campagna avviato!');
        setTimeout(() => this.loadCampaigns(), 2000);
      } catch (error) {
        console.error('Error starting campaign:', error);
        alert('Errore: ' + (error.response?.data?.message || error.message));
      } finally {
        this.isLoading = false;
      }
    },
    async loadCampaigns() {
      try {
        const apiBase = this.store.path || 'http://localhost:5000/login/';
        const endpoint = apiBase.endsWith('/') ? `${apiBase}social/campaigns` : `${apiBase}/social/campaigns`;
        
        let token = '';
        try {
            if (localStorage.token && localStorage.token !== 'undefined') {
                token = JSON.parse(localStorage.token);
            }
        } catch(e) {
            token = localStorage.token;
        }

        const res = await this.axios.get(endpoint, {
          params: { userId: this.userId },
          headers: {
            authorization: `Bearer ${token}`
          }
        });
        
        this.campaigns = Array.isArray(res.data) ? res.data : [];
      } catch (error) {
        console.error('Error loading campaigns:', error);
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      return date.toLocaleDateString('it-IT');
    },
    getImageUrl(img) {
      if (!img) return '';
      if (img.startsWith('http')) return img;
      let apiBase = (this.store.path || 'http://localhost:5000/login/').replace('/login/', '');
      if (apiBase.endsWith('/')) apiBase = apiBase.slice(0, -1);
      const cleanImg = img.startsWith('/') ? img : `/${img}`;
      return `${apiBase}${cleanImg}`;
    },
    getStatusBadgeClass(status) {
      const classes = {
        'DRAFT': 'bg-light text-dark border',
        'PENDING_AGENT': 'bg-warning-soft text-warning',
        'ACTIVE': 'bg-success-soft text-success',
        'PAUSED': 'bg-info-soft text-info',
        'COMPLETED': 'bg-dark-soft text-muted',
        'FAILED': 'bg-danger-soft text-danger'
      };
      return classes[status] || 'bg-secondary';
    },
    getStatusLabel(status) {
      const labels = {
        'DRAFT': 'Bozza',
        'PENDING_AGENT': 'In elaborazione',
        'ACTIVE': 'Attiva',
        'PAUSED': 'Pausa',
        'COMPLETED': 'Conclusa',
        'FAILED': 'Errore'
      };
      return labels[status] || status;
    },
    getCampaignTypeLabel(type) {
      const labels = {
        'awareness': 'Brand Awareness',
        'consideration': 'Consideration',
        'conversion': 'Conversion'
      };
      return labels[type] || 'Social Ad';
    },
    getTypeBadgeClass(type) {
      const classes = {
        'awareness': 'bg-primary-soft text-primary',
        'consideration': 'bg-purple-soft text-purple',
        'conversion': 'bg-teal-soft text-teal'
      };
      return classes[type] || 'bg-light text-muted';
    }
  }
}
</script>

<style scoped>
.social-campaigns {
  background-color: #f8f9fa;
  min-height: 100vh;
  font-family: 'Inter', system-ui, sans-serif;
}

/* Glassmorphism */
.glass-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 1.25rem;
  box-shadow: 0 10px 30px -10px rgba(0,0,0,0.05);
}

.icon-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
}

/* Campaigns Cards */
.campaign-card {
  background: #fff;
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 1.25rem;
  padding: 1.5rem;
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.campaign-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px -10px rgba(0,0,0,0.1);
  border-color: #3f51b540;
}

.campaign-card.is-active {
  border-left: 5px solid #198754;
}

.ad-preview-box {
  background-color: #f8f9fa;
}

.ad-text {
  font-size: 0.85rem;
  line-height: 1.5;
  color: #333;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ad-image-container {
  height: 180px;
  background-color: #f0f0f0;
}

.ad-image-placeholder {
  height: 180px;
  border: 2px dashed #e0e0e0;
}

/* Header & Filters */
.month-title {
  position: relative;
  display: flex;
  align-items: center;
  color: #2c3e50;
  font-weight: 700;
  text-transform: capitalize;
}

.title-line {
  flex-grow: 1;
  height: 2px;
  background: linear-gradient(to right, rgba(0,0,0,0.1), transparent);
  margin-left: 1rem;
}

.search-bar {
  position: relative;
  width: 200px;
}

.search-bar i {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
  font-size: 0.8rem;
}

.search-bar input {
  padding-left: 30px;
  border-radius: 20px;
  font-size: 0.85rem;
}

.status-filter {
  width: 140px;
  border-radius: 20px;
  font-size: 0.85rem;
}

/* Soft Colors */
.bg-primary-soft { background-color: rgba(13, 110, 253, 0.08); }
.bg-success-soft { background-color: rgba(25, 135, 84, 0.08); }
.bg-warning-soft { background-color: rgba(255, 193, 7, 0.08); }
.bg-info-soft { background-color: rgba(13, 202, 240, 0.08); }
.bg-danger-soft { background-color: rgba(220, 53, 69, 0.08); }
.bg-purple-soft { background-color: rgba(111, 66, 193, 0.08); }
.bg-teal-soft { background-color: rgba(32, 201, 151, 0.08); }
.bg-dark-soft { background-color: rgba(33, 37, 41, 0.04); }

.text-purple { color: #6f42c1; }
.text-teal { color: #20c997; }

.border-dashed { border-style: dashed !important; }

@media (max-width: 991px) {
  .config-sidebar {
    position: static !important;
  }
}
</style>
